export function hasLocationService(): boolean {
  return 'geolocation' in navigator;
}
